import React from "react";
import { Navigate as RouterNavigate, NavigateProps as RouterNavigateProps } from "react-router-dom";

export interface NavigateProps extends RouterNavigateProps {
  // Extending the original NavigateProps if needed
}

export const Navigate: React.FC<NavigateProps> = ({ to, replace = false, state, ...rest }) => {
  return <RouterNavigate to={to} replace={replace} state={state} {...rest} />;
};
